import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import safeStorage from "@/lib/safeStorage";
import { makeT } from "@/lib/i18n";
import { useAuth } from "@/context/AuthContext";

const LangCtx = createContext({ lang: "en", t: (k) => k, setLang: () => {}, refresh: () => {} });

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(safeStorage.getItem("lang") || "en");
  const { user, ready } = useAuth();

  const load = useCallback(async () => {
    if (!ready || !user) return;
    try {
      const { data } = await api.get("/settings");
      if (data?.language) {
        setLang(data.language);
        safeStorage.setItem("lang", data.language);
      }
    } catch {
      /* ignore */
    }
  }, [ready, user]);

  useEffect(() => {
    load();
  }, [load]);

  const t = makeT(lang);
  return (
    <LangCtx.Provider value={{ lang, setLang, t, refresh: load }}>
      {children}
    </LangCtx.Provider>
  );
}

export const useLang = () => useContext(LangCtx);
